'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.fonts.edit', [])
  .controller('FontsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/fonts/edit/index.js